module.exports = __webpack_public_path__ + "img/zanwu.67d2fa50.png";